export default __webpack_public_path__ + "static/7-holiday-car-hire-6ddc664e0d8ce22694ff60c0cf0e40e3.jpg";